import { useQuery } from "@tanstack/react-query";
import { hrEmployerApi } from "@/lib/api/hr";
import { EmptyState, Page, QueryGate } from "@/components/shell/page";

export default function EmployerAuditPage() {
  const { data, isLoading, error } = useQuery({
    queryKey: ["hr", "employer", "audit"],
    queryFn: () => hrEmployerApi.audit(),
  });

  return (
    <QueryGate loading={isLoading} error={error ? "Could not load the audit log." : null}>
      <Page title="Audit log" description="Who changed a record, what changed, and when.">
        {(data ?? []).length === 0 && (
          <EmptyState title="No audit entries" body="Important changes will be listed here." />
        )}
        <ol className="space-y-3">
          {(data ?? []).map((row: any) => (
            <li key={row.id} className="rounded-xl border bg-card p-4 shadow-sm">
              <p className="font-medium">
                {row.action} · {row.entity_type}
              </p>
              <p className="mt-1 text-sm text-muted-foreground">
                {row.actor} · {row.created_at}
                {row.employee_id ? ` · employee ${row.employee_id}` : ""}
              </p>
              {row.reason && <p className="mt-2 text-sm">{row.reason}</p>}
            </li>
          ))}
        </ol>
      </Page>
    </QueryGate>
  );
}
